;(function () {
  'use strict'

  angular.module('contrast.date').constant('csDateRangePickerFormats', {
    RANGE_INPUTS: 'MMM DD YYYY',
    UIB_FORMAT_DAY_TITLE: 'MMM yyyy',
    UIB_FORMAT_DAY: 'd',
    HIGHLIGHT_DAY_FORMAT: 'DD MMMM YYYY'
  })
})()
